<div class="modal-container">
  <div class="body">
    <div class="header-table">
      <p class="title-table">Participantes</p>
      <button class="closed" (click)="clearBody()">
        <img src="../../../../assets/svgs/close_btn.svg" alt="Closed">
      </button>
    </div>
    <div class="tm-container">
      <div class="tm-filter">
        <div class="tm-element">
          <div class="element-column">
            <div class="tm-input">
              <input 
                type="text"
                class="tm-input-control"
                name="tm-search"
                id="search-team-member"
                placeholder="Buscar"
                maxlength="100"
                autocomplete="off">
              <button class="btn-search">
                <img src="../../assets/svgs/search.svg" alt="search">
              </button>
            </div>
          </div>
          <button 
            class="btn-options"
            [ngClass]="{'open-modal': isOpenMenu}"
            [matMenuTriggerFor]="beforeMenu"
            (click)="isOpenMenu = !isOpenMenu"
            *ngIf="selectedParticipants.length >= 1">
            <span class="btn-text">Ações</span>
            <img src="../../assets/svgs/arrow_down.svg" alt="Icon">
          </button>
          <mat-menu #beforeMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="actionsParticipants()">Remover</button>
          </mat-menu>
        </div>
      </div>
      <div class="tbl">
        <app-team-management-table
        [listHeaders]="listHeaders"
        [listBinding]="listBinding"
        [positioType]="true"
        (sendIndex)="sendIndex($event)"
        (sendOptions)="sendParticipants($event)"
        (sendItemSelections)="sendItemSelections($event)"
        (sendSelections)="sendAllSelections($event)"  
      ></app-team-management-table>
      </div>
    </div>
  </div>
</div>